import React from "react";
import ServiceHero from "../../components/ServiceHero";
import Client from "../../pages/client/Client";
// import Plan from "../../components/Plan";
import Services1 from "../../components/Services1";
import FAQ from "../../components/FAQ";
import Footer from "../Footer/Footer";
import WebDesignPre from "./WebDesignPre";

import FormHeroSection from "../../components/FormHeroSection";

const WebDesign = () => {
  return (
    <>
      <ServiceHero
        eyebrow="Web Design"
        title="Design that earns"
        highlight="attention and action."
        description="We design modern, distinctive websites that communicate your value clearly, guide visitors naturally, and turn brand interest into measurable action."
        features={[
          "Distinctive visual direction",
          "Conversion-aware layouts",
          "Responsive by design",
        ]}
        image="/Images/webDesignHome.png"
        imageAlt="Illustration of a team creating a modern website interface"
        visualLabel="Designed with purpose"
        visualTitle="Every screen working harder for your brand."
      />
      <Client />
      <FormHeroSection />
      <Services1 />
      {/* <Plan
        planHeading="CERTIFIED CONTENT MARKETING COMPANY"
        planRate="$149"
        planSubheding="Abscod is one of the best Website Development"
        user1="Single User"
        Strorage="500 GB Storage"
        userAcces="Send up to 2 GB"
        dataCapcity="Send up to 2 GB"
        user2="Single User"
        user3="Single User"
        Strorage2="500 GB Storage"
        Strorage3="500 GB Storage"
        userAcces2="1 Granted User"
        userAcces3="1 Granted User"
        dataCapcity2="1 Granted User"
        dataCapcity3="Send up to 2 GB"
        planRate2="$149"
        planRate3="$149"
      /> */}
      <WebDesignPre />
      <FAQ
        title="What is web design?"
        title1="What is user experience (UX) design?"
        title2="What is user interface (UI) design?"
        title3="Why is good web design important for my business?"
        title4="What is the difference between UX and UI design?"
        paragraph="Web design is the process of creating the visual and functional elements of a website, including layout, color scheme, typography, and imagery. It involves both the creative and technical aspects of designing a website."
        paragraph1="User experience (UX) design is the process of creating websites that are optimized for usability and user satisfaction. It involves understanding the user's needs and behavior and designing a website that meets those needs and is easy to use."
        paragraph2="User interface (UI) design is the process of creating the visual and interactive elements of a website, including buttons, forms, and menus. It focuses on making the website visually appealing and easy to use."
        paragraph3="Good web design is important for your business because it can impact your website's performance and user engagement. A well-designed website can help you attract and retain customers, build trust and credibility, and increase conversions and revenue."
        paragraph4="UX design focuses on the overall experience and usability of a website, while UI design focuses on the visual and interactive elements of a website. UX designers prioritize functionality and user satisfaction, while UI designers prioritize aesthetics and user engagement. Both are important aspects of web design and should be considered when creating a website."
      />
      <Footer />
    </>
  );
};

export default WebDesign;
